/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenter } from '../../models/work-center';

export interface GetWorkCenter$Params {
  workCenterId: number;
}

export function getWorkCenter(http: HttpClient, rootUrl: string, params: GetWorkCenter$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkCenter>> {
  const rb = new RequestBuilder(rootUrl, getWorkCenter.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkCenter>;
    })
  );
}

getWorkCenter.PATH = '/api/v1/WorkCenter/{workCenterId}';
